import { useContext } from "react";
import { ProjectContext, TProjectContextValue } from "./ProjectContext";

const useProject = (): TProjectContextValue => {
  const context = useContext(ProjectContext);

  if (context === undefined) {
    throw new Error("useProject must be used within a ProjectProvider");
  }

  return context;
};

export default useProject;
